<ng-container *ngIf="navLinks">
  <li class="dropdown main-nav dotcms-custom-menu" *ngFor="let navLink of navLinks?.children; let i = index">
    <ng-container *ngIf="navLink.type !== 'folder'; else folderNav">
      <a [routerLink]="dotCMSHeaderNavigationLink(navLink.href)">{{ navLink.title }}</a>
    </ng-container>
    <ng-template #folderNav>
      <ng-container *ngIf="navLink.children.length > 0; else folderWithNoPages">
        <div
          (mouseenter)="manageLeft(i, $event)"
          [ngClass]="'link' + i"
          [id]="'link' + i"
          class="dropdown dot-cms-header-nav"
        >
          <custom-dot-cms-header-folder-index-page-check
            [navLink]="navLink"
            [dropDownLayer]="i"
            [depth]="i - i"
            deviceType="desktop"
          ></custom-dot-cms-header-folder-index-page-check>
          <ng-container *ngIf="0 < mainNavigationMaxSubCategoriesDepth && navLink.children.length > 0">
            <div
              #nav
              [attr.id]="'dot-cms-header-flyout' + i"
              class="dotcms-flyout d-none"
              [ngClass]="'dot-cms-header-flyout' + i"
            >
              <ng-container *ngIf="navLink?.children?.length > 0">
                <!--This is the sub folder container -->
                <ul>
                  <custom-dot-cms-sub-folder-header-navigation
                    [subFolderItems]="navLink.children"
                    [depth]="depth"
                    [folderIndex]="i"
                    deviceType="desktop"
                  ></custom-dot-cms-sub-folder-header-navigation>
                </ul>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #folderWithNoPages>
        <div class="dot-cms-header-nav">
          <div class="disable-links0 empty-folder">{{ navLink.title }}</div>
        </div>
      </ng-template>
    </ng-template>
  </li>
</ng-container>
